import axios from "axios";
import { auth } from "../Services/firebaseAuth";

const baseURL = process.env.REACT_APP_API_BASE_URL;

// Create Axios instance
const instance = axios.create({ baseURL });

let isRefreshing = false; // Prevents multiple refresh attempts

// Function to get a valid Firebase token
const getFirebaseToken = async () => {
  const user = auth.currentUser;

  if (user) {
    try {
      const idToken = await user.getIdToken(true); // Force refresh
      localStorage.setItem("accessToken", idToken); // Store new token
      return idToken;
    } catch (error) {
      console.error("Error refreshing Firebase token:", error);
    }
  }
  return null;
};

// Attach token to requests
instance.interceptors.request.use(async (config) => {
  let token = localStorage.getItem("accessToken");

  // If token is missing, try fetching a new one
  if (!token) {
    token = await getFirebaseToken();
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const lang = process.env.REACT_APP_LANG || 'en';
  config.headers['Accept-Language'] = lang;
  return config;
}, (error) => Promise.reject(error));

// Handle 401 Unauthorized errors
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401  && !originalRequest._retry) {
      console.warn("Unauthorized request, attempting token refresh.");

      // Prevent multiple refresh attempts
      if (isRefreshing) {
        return Promise.reject(error);
      }
      isRefreshing = true;

      const newToken = await getFirebaseToken();

      if (newToken) {
        // Retry the failed request with the new token
        originalRequest._retry = true;
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        isRefreshing = false;
        return instance(originalRequest);
      } else {
        auth.signOut();
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
      }
    }
     if(error?.response && error?.response?.status === 403 && error?.response?.data?.errorCode === 8511){ 
      auth.signOut();
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export { instance };
